module.exports = {
      id: "logo-usage",
      viewBox: "0 0 129 34",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#logo",
      toString: function () {
        return this.url;
      }
    }